import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import REFINANCEIRQSeeVaLoanOptionsView from "../views/IrqSeeVaLoanOptionsView";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { bool, object } from "yup";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqSeeVaLoanOptionsPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="refinanceIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            lookAtVaLoans: bool().required(),
          })}
        >
          <REFINANCEIRQSeeVaLoanOptionsView
            content={contentMap.RefinanceIrqSeeVaLoanOptionsPage}
            navigationsAway={
              customNavigationMap.RefinanceIrqSeeVaLoanOptionsPage
            }
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceIrqSeeVaLoanOptionsPage);
